import { isMobileDevice } from '@Core/utility';

const setContentHeight = () => {
  const headerHeight = document.querySelector(
    '[data-comp-navigationheader]',
  ).offsetHeight;
  const initialHeight = isMobileDevice() ? `${window.innerHeight}px` : '100vh';
  const contentContainer = document.querySelector('.location-search');

  // Subtract the header height
  contentContainer.style.height = `calc(${initialHeight} - ${headerHeight}px)`;
};

export { setContentHeight };
